<app-layout-header></app-layout-header>

<router-outlet></router-outlet>

<app-layout-footer></app-layout-footer>
